const ENUMS = Object.freeze({
    WALLET: {
        DISCONNECTED: 0
        , CONNECED: 1
        , NOT_AVAILABLE: 3
    }
    , VIEWS: {
        MAIN: "CoalViewMain"
        , MYNFTS: "CoalViewMyNFTs"
        , LISTNFTS: "CoalViewListNFTs"
        , LISTONSALE: "CoalViewListOnSale"
        , MINT: "CoalViewMint"
        , HELP: "CoalViewHelp"
        , MINE: "CoalViewMine"
        , HEISTS: "CoalViewHeists"
        , DEBUG: "CoalViewDebug"
        , SETTINGS: "CoalViewSettings"
        , QUERY: "CoalQuery"
        , TRACK: "CoalViewTrack"
        ,SACRIFICE:"CoalViewSacrifice"
    }
    , WORKER: {
        RUNNING: 0
        , STOPPED: 1
    },
    QUERY_ITEM_STATUS: {
        LOADING: 0
        , DONE: 1
        , FAIL: 2
    }
    , QUERY_IMPORTANCE: {
        NOT_IMPORTANT: 0
    }
    , HEIST_TYPE: {
        MINED: 0
        , MANUAL: 1
        , IN_MINE: 2
    }
    , NFR_STATE: {
        NOT_LOOKED: 0
        , LOCKED_IN_MY_NAME: 1
        , LOCKED_IN_OTHER_NAME: 2
        , NOT_FOUND: 3
    }, EMOJI2:
    {
        "HAT": {
            "SKULL": "💀",
            "SKULL_AND_CROSSBONES": "☠",
            "PILE_OF_POO": "💩",
            "DIZZY": "💫",
            "ZZZ": "💤",
            "NOSE": "👃",
            "BRAIN": "🧠",
            "TOOTH": "🦷",
            "EYES": "👀",
            "EYE": "👁",
            "TONGUE": "👅",
            "PIG_NOSE": "🐽",
            "FEATHER": "🪶",
            "CHERRY_BLOSSOM": "🌸",
            "WHITE_FLOWER": "💮",
            "LOTUS": "🪷",
            "BLOSSOM": "🌼",
            "HERB": "🌿",
            "SHAMROCK": "☘",
            "FOUR_LEAF_CLOVER": "🍀",
            "MAPLE_LEAF": "🍁",
            "EMPTY_NEST": "🪹",
            "NEST_WITH_EGGS": "🪺",
            "MUSHROOM": "🍄",
            "EGG": "🥚",
            "HIGH_VOLTAGE": "⚡",
            "SPARKLES": "✨",
            "RIBBON": "🎀",
            "DIVING_MASK": "🤿",
            "GLASSES": "👓",
            "SUNGLASSES": "🕶",
            "GOGGLES": "🥽",
            "CROWN": "👑",
            "WOMAN’S_HAT": "👒",
            "TOP_HAT": "🎩",
            "GRADUATION_CAP": "🎓",
            "BILLED_CAP": "🧢",
            "MILITARY_HELMET": "🪖",
            "RESCUE_WORKER’S_HELMET": "⛑",
            "GEM_STONE": "💎",
            "HEADPHONE": "🎧",
            "CANDLE": "🕯",
            "LIGHT_BULB": "💡",
            "ADHESIVE_BANDAGE": "🩹"
        },
        "HAND": {
            "HEART_WITH_RIBBON": "💝",
            "SPARKLING_HEART": "💖",
            "SWEAT_DROPLETS": "💦",
            "DASHING_AWAY": "💨",
            "VULCAN_SALUTE": "🖖",
            "OK_HAND": "👌",
            "PINCHING_HAND": "🤏",
            "HAND_WITH_INDEX_FINGER_AND_THUMB_CROSSED": "🫰",
            "SIGN_OF_THE_HORNS": "🤘",
            "MIDDLE_FINGER": "🖕",
            "THUMBS_UP": "👍",
            "THUMBS_DOWN": "👎",
            "ONCOMING_FIST": "👊",
            "HEART_HANDS": "🫶",
            "FOLDED_HANDS": "🙏",
            "ANATOMICAL_HEART": "🫀",
            "BONE": "🦴",
            "⊛_WING": "🪽",
            "BOUQUET": "💐",
            "ROSE": "🌹",
            "WILTED_FLOWER": "🥀",
            "TULIP": "🌷",
            "GRAPES": "🍇",
            "MELON": "🍈",
            "WATERMELON": "🍉",
            "TANGERINE": "🍊",
            "LEMON": "🍋",
            "BANANA": "🍌",
            "PINEAPPLE": "🍍",
            "MANGO": "🥭",
            "RED_APPLE": "🍎",
            "GREEN_APPLE": "🍏",
            "PEAR": "🍐",
            "PEACH": "🍑",
            "CHERRIES": "🍒",
            "STRAWBERRY": "🍓",
            "BLUEBERRIES": "🫐",
            "KIWI_FRUIT": "🥝",
            "TOMATO": "🍅",
            "OLIVE": "🫒",
            "COCONUT": "🥥",
            "AVOCADO": "🥑",
            "EGGPLANT": "🍆",
            "POTATO": "🥔",
            "CARROT": "🥕",
            "EAR_OF_CORN": "🌽",
            "HOT_PEPPER": "🌶",
            "BELL_PEPPER": "🫑",
            "CUCUMBER": "🥒",
            "LEAFY_GREEN": "🥬",
            "BROCCOLI": "🥦",
            "GARLIC": "🧄",
            "ONION": "🧅",
            "PEANUTS": "🥜",
            "BEANS": "🫘",
            "CHESTNUT": "🌰",
            "⊛_GINGER_ROOT": "🫚",
            "⊛_PEA_POD": "🫛",
            "BREAD": "🍞",
            "CROISSANT": "🥐",
            "BAGUETTE_BREAD": "🥖",
            "PRETZEL": "🥨",
            "BAGEL": "🥯",
            "PANCAKES": "🥞",
            "WAFFLE": "🧇",
            "CHEESE_WEDGE": "🧀",
            "MEAT_ON_BONE": "🍖",
            "POULTRY_LEG": "🍗",
            "CUT_OF_MEAT": "🥩",
            "BACON": "🥓",
            "HAMBURGER": "🍔",
            "FRENCH_FRIES": "🍟",
            "PIZZA": "🍕",
            "HOT_DOG": "🌭",
            "SANDWICH": "🥪",
            "TACO": "🌮",
            "BURRITO": "🌯",
            "TAMALE": "🫔",
            "STUFFED_FLATBREAD": "🥙",
            "FALAFEL": "🧆",
            "COOKING": "🍳",
            "POPCORN": "🍿",
            "SALT": "🧂",
            "RICE_CRACKER": "🍘",
            "RICE_BALL": "🍙",
            "SUSHI": "🍣",
            "FORTUNE_COOKIE": "🥠",
            "TAKEOUT_BOX": "🥡",
            "SOFT_ICE_CREAM": "🍦",
            "SHAVED_ICE": "🍧",
            "ICE_CREAM": "🍨",
            "DOUGHNUT": "🍩",
            "COOKIE": "🍪",
            "BIRTHDAY_CAKE": "🎂",
            "SHORTCAKE": "🍰",
            "CUPCAKE": "🧁",
            "PIE": "🥧",
            "CHOCOLATE_BAR": "🍫",
            "CANDY": "🍬",
            "LOLLIPOP": "🍭",
            "HONEY_POT": "🍯",
            "BABY_BOTTLE": "🍼",
            "HOT_BEVERAGE": "☕",
            "TEAPOT": "🫖",
            "SAKE": "🍶",
            "BOTTLE_WITH_POPPING_CORK": "🍾",
            "WINE_GLASS": "🍷",
            "COCKTAIL_GLASS": "🍸",
            "TROPICAL_DRINK": "🍹",
            "BEER_MUG": "🍺",
            "CLINKING_GLASSES": "🥂",
            "TUMBLER_GLASS": "🥃",
            "POURING_LIQUID": "🫗",
            "CUP_WITH_STRAW": "🥤",
            "BUBBLE_TEA": "🧋",
            "BEVERAGE_BOX": "🧃",
            "MATE": "🧉",
            "CHOPSTICKS": "🥢",
            "FORK_AND_KNIFE": "🍴",
            "SPOON": "🥄",
            "KITCHEN_KNIFE": "🔪",
            "JAR": "🫙",
            "AMPHORA": "🏺",
            "COMPASS": "🧭",
            "ROCK": "🪨",
            "WOOD": "🪵",
            "LUGGAGE": "🧳",
            "WATCH": "⌚",
            "CLOSED_UMBRELLA": "🌂",
            "UMBRELLA": "☂",
            "FIRECRACKER": "🧨",
            "BALLOON": "🎈",
            "PARTY_POPPER": "🎉",
            "WRAPPED_GIFT": "🎁",
            "TROPHY": "🏆",
            "SOCCER_BALL": "⚽",
            "BASEBALL": "⚾",
            "SOFTBALL": "🥎",
            "BASKETBALL": "🏀",
            "VOLLEYBALL": "🏐",
            "AMERICAN_FOOTBALL": "🏈",
            "RUGBY_FOOTBALL": "🏉",
            "TENNIS": "🎾",
            "FLYING_DISC": "🥏",
            "BOWLING": "🎳",
            "PING_PONG": "🏓",
            "BADMINTON": "🏸",
            "BOXING_GLOVE": "🥊",
            "YO-YO": "🪀",
            "KITE": "🪁",
            "POOL_8_BALL": "🎱",
            "MAGIC_WAND": "🪄",
            "VIDEO_GAME": "🎮",
            "JOYSTICK": "🕹",
            "GAME_DIE": "🎲",
            "TEDDY_BEAR": "🧸",
            "ARTIST_PALETTE": "🎨",
            "THREAD": "🧵",
            "YARN": "🧶",
            "⊛_FOLDING_HAND_FAN": "🪭",
            "PURSE": "👛",
            "HANDBAG": "👜",
            "CLUTCH_BAG": "👝",
            "SHOPPING_BAGS": "🛍",
            "BACKPACK": "🎒",
            "THONG_SANDAL": "🩴",
            "PRAYER_BEADS": "📿",
            "RING": "💍",
            "LOUDSPEAKER": "📢",
            "MEGAPHONE": "📣",
            "POSTAL_HORN": "📯",
            "BELL": "🔔",
            "MICROPHONE": "🎤",
            "SAXOPHONE": "🎷",
            "ACCORDION": "🪗",
            "GUITAR": "🎸",
            "MUSICAL_KEYBOARD": "🎹",
            "TRUMPET": "🎺",
            "VIOLIN": "🎻",
            "BANJO": "🪕",
            "DRUM": "🥁",
            "LONG_DRUM": "🪘",
            "⊛_MARACAS": "🪇",
            "⊛_FLUTE": "🪈",
            "MOBILE_PHONE": "📱",
            "TELEPHONE_RECEIVER": "📞",
            "PAGER": "📟",
            "KEYBOARD": "⌨",
            "COMPUTER_MOUSE": "🖱",
            "COMPUTER_DISK": "💽",
            "FLOPPY_DISK": "💾",
            "OPTICAL_DISK": "💿",
            "DVD": "📀",
            "ABACUS": "🧮",
            "MOVIE_CAMERA": "🎥",
            "CLAPPER_BOARD": "🎬",
            "CAMERA": "📷",
            "CAMERA_WITH_FLASH": "📸",
            "VIDEO_CAMERA": "📹",
            "VIDEOCASSETTE": "📼",
            "MAGNIFYING_GLASS_TILTED_LEFT": "🔍",
            "MAGNIFYING_GLASS_TILTED_RIGHT": "🔎",
            "FLASHLIGHT": "🔦",
            "NOTEBOOK": "📓",
            "SCROLL": "📜",
            "NEWSPAPER": "📰",
            "ROLLED-UP_NEWSPAPER": "🗞",
            "MONEY_BAG": "💰",
            "COIN": "🪙",
            "YEN_BANKNOTE": "💴",
            "DOLLAR_BANKNOTE": "💵",
            "EURO_BANKNOTE": "💶",
            "POUND_BANKNOTE": "💷",
            "MONEY_WITH_WINGS": "💸",
            "PENCIL": "✏",
            "FOUNTAIN_PEN": "🖋",
            "PAINTBRUSH": "🖌",
            "CRAYON": "🖍",
            "BRIEFCASE": "💼",
            "FILE_FOLDER": "📁",
            "STRAIGHT_RULER": "📏",
            "TRIANGULAR_RULER": "📐",
            "SCISSORS": "✂",
            "KEY": "🔑",
            "OLD_KEY": "🗝",
            "HAMMER": "🔨",
            "AXE": "🪓",
            "PICK": "⛏",
            "HAMMER_AND_PICK": "⚒",
            "HAMMER_AND_WRENCH": "🛠",
            "DAGGER": "🗡",
            "BOMB": "💣",
            "BOOMERANG": "🪃",
            "BOW_AND_ARROW": "🏹",
            "SHIELD": "🛡",
            "CARPENTRY_SAW": "🪚",
            "WRENCH": "🔧",
            "SCREWDRIVER": "🪛",
            "WHITE_CANE": "🦯",
            "HOOK": "🪝",
            "TOOLBOX": "🧰",
            "MAGNET": "🧲",
            "TEST_TUBE": "🧪",
            "SYRINGE": "💉",
            "CRUTCH": "🩼",
            "PLUNGER": "🪠",
            "BROOM": "🧹",
            "ROLL_OF_PAPER": "🧻",
            "SOAP": "🧼",
            "SPONGE": "🧽",
            "FIRE_EXTINGUISHER": "🧯",
            "SHOPPING_CART": "🛒",
            "CIGARETTE": "🚬",
            "HEAVY_DOLLAR_SIGN": "💲",
            "TRIDENT_EMBLEM": "🔱",
            "CHEQUERED_FLAG": "🏁",
            "TRIANGULAR_FLAG": "🚩",
            "BLACK_FLAG": "🏴"
        },
        "SKY": {
            "COLLISION": "💥",
            "SNOW-CAPPED_MOUNTAIN": "🏔",
            "MOUNTAIN": "⛰",
            "VOLCANO": "🌋",
            "MOUNT_FUJI": "🗻",
            "NIGHT_WITH_STARS": "🌃",
            "SUNRISE_OVER_MOUNTAINS": "🌄",
            "SUNRISE": "🌅",
            "CITYSCAPE_AT_DUSK": "🌆",
            "SUNSET": "🌇",
            "ROCKET": "🚀",
            "FLYING_SAUCER": "🛸",
            "CRESCENT_MOON": "🌙",
            "NEW_MOON_FACE": "🌚",
            "FIRST_QUARTER_MOON_FACE": "🌛",
            "LAST_QUARTER_MOON_FACE": "🌜",
            "FULL_MOON_FACE": "🌝",
            "SUN_WITH_FACE": "🌞",
            "RINGED_PLANET": "🪐",
            "STAR": "⭐",
            "GLOWING_STAR": "🌟",
            "SHOOTING_STAR": "🌠",
            "MILKY_WAY": "🌌",
            "SUN_BEHIND_CLOUD": "⛅",
            "CYCLONE": "🌀",
            "RAINBOW": "🌈",
            "SNOWFLAKE": "❄",
            "COMET": "☄",
            "FIREWORKS": "🎆",
            "SPARKLER": "🎇",
            "MOON_VIEWING_CEREMONY": "🎑",
            "BUBBLES": "🫧",
            "ARIES": "♈",
            "TAURUS": "♉",
            "GEMINI": "♊",
            "CANCER": "♋",
            "LEO": "♌",
            "VIRGO": "♍",
            "LIBRA": "♎",
            "SCORPIO": "♏",
            "SAGITTARIUS": "♐",
            "CAPRICORN": "♑",
            "AQUARIUS": "♒",
            "PISCES": "♓",
            "OPHIUCHUS": "⛎"
        },
        "PET": {
            "SMILING_FACE_WITH_HORNS": "😈",
            "ANGRY_FACE_WITH_HORNS": "👿",
            "OGRE": "👹",
            "GOBLIN": "👺",
            "GHOST": "👻",
            "ALIEN": "👽",
            "ALIEN_MONSTER": "👾",
            "ROBOT": "🤖",
            "GRINNING_CAT": "😺",
            "GRINNING_CAT_WITH_SMILING_EYES": "😸",
            "CAT_WITH_TEARS_OF_JOY": "😹",
            "SMILING_CAT_WITH_HEART-EYES": "😻",
            "CAT_WITH_WRY_SMILE": "😼",
            "KISSING_CAT": "😽",
            "WEARY_CAT": "🙀",
            "CRYING_CAT": "😿",
            "POUTING_CAT": "😾",
            "SEE-NO-EVIL_MONKEY": "🙈",
            "HEAR-NO-EVIL_MONKEY": "🙉",
            "SPEAK-NO-EVIL_MONKEY": "🙊",
            "FAIRY": "🧚",
            "MAN_FAIRY": "🧚‍♂️",
            "WOMAN_FAIRY": "🧚‍♀️",
            "GENIE": "🧞",
            "MAN_GENIE": "🧞‍♂️",
            "WOMAN_GENIE": "🧞‍♀️",
            "TROLL": "🧌",
            "MONKEY_FACE": "🐵",
            "MONKEY": "🐒",
            "GORILLA": "🦍",
            "ORANGUTAN": "🦧",
            "DOG_FACE": "🐶",
            "DOG": "🐕",
            "POODLE": "🐩",
            "WOLF": "🐺",
            "FOX": "🦊",
            "RACCOON": "🦝",
            "CAT_FACE": "🐱",
            "CAT": "🐈",
            "BLACK_CAT": "🐈‍⬛",
            "LION": "🦁",
            "TIGER_FACE": "🐯",
            "TIGER": "🐅",
            "LEOPARD": "🐆",
            "HORSE_FACE": "🐴",
            "⊛_MOOSE": "🫎",
            "⊛_DONKEY": "🫏",
            "HORSE": "🐎",
            "UNICORN": "🦄",
            "ZEBRA": "🦓",
            "DEER": "🦌",
            "BISON": "🦬",
            "COW_FACE": "🐮",
            "OX": "🐂",
            "WATER_BUFFALO": "🐃",
            "COW": "🐄",
            "PIG_FACE": "🐷",
            "PIG": "🐖",
            "BOAR": "🐗",
            "RAM": "🐏",
            "EWE": "🐑",
            "GOAT": "🐐",
            "CAMEL": "🐪",
            "TWO-HUMP_CAMEL": "🐫",
            "LLAMA": "🦙",
            "GIRAFFE": "🦒",
            "ELEPHANT": "🐘",
            "MAMMOTH": "🦣",
            "RHINOCEROS": "🦏",
            "HIPPOPOTAMUS": "🦛",
            "MOUSE_FACE": "🐭",
            "MOUSE": "🐁",
            "RAT": "🐀",
            "HAMSTER": "🐹",
            "RABBIT_FACE": "🐰",
            "RABBIT": "🐇",
            "CHIPMUNK": "🐿",
            "BEAVER": "🦫",
            "HEDGEHOG": "🦔",
            "BAT": "🦇",
            "BEAR": "🐻",
            "POLAR_BEAR": "🐻‍❄️",
            "KOALA": "🐨",
            "PANDA": "🐼",
            "SLOTH": "🦥",
            "OTTER": "🦦",
            "SKUNK": "🦨",
            "KANGAROO": "🦘",
            "BADGER": "🦡",
            "TURKEY": "🦃",
            "CHICKEN": "🐔",
            "ROOSTER": "🐓",
            "HATCHING_CHICK": "🐣",
            "BABY_CHICK": "🐤",
            "FRONT-FACING_BABY_CHICK": "🐥",
            "BIRD": "🐦",
            "PENGUIN": "🐧",
            "DOVE": "🕊",
            "EAGLE": "🦅",
            "DUCK": "🦆",
            "SWAN": "🦢",
            "OWL": "🦉",
            "DODO": "🦤",
            "FLAMINGO": "🦩",
            "PEACOCK": "🦚",
            "PARROT": "🦜",
            "⊛_BLACK_BIRD": "🐦‍⬛",
            "⊛_GOOSE": "🪿",
            "FROG": "🐸",
            "CROCODILE": "🐊",
            "TURTLE": "🐢",
            "LIZARD": "🦎",
            "SNAKE": "🐍",
            "DRAGON_FACE": "🐲",
            "DRAGON": "🐉",
            "SAUROPOD": "🦕",
            "T-REX": "🦖",
            "SPOUTING_WHALE": "🐳",
            "WHALE": "🐋",
            "DOLPHIN": "🐬",
            "SEAL": "🦭",
            "FISH": "🐟",
            "TROPICAL_FISH": "🐠",
            "BLOWFISH": "🐡",
            "SHARK": "🦈",
            "OCTOPUS": "🐙",
            "⊛_JELLYFISH": "🪼",
            "SNAIL": "🐌",
            "BUTTERFLY": "🦋",
            "BUG": "🐛",
            "ANT": "🐜",
            "HONEYBEE": "🐝",
            "BEETLE": "🪲",
            "LADY_BEETLE": "🐞",
            "CRICKET": "🦗",
            "COCKROACH": "🪳",
            "SPIDER": "🕷",
            "SCORPION": "🦂",
            "MOSQUITO": "🦟",
            "FLY": "🪰",
            "WORM": "🪱",
            "MICROBE": "🦠",
            "CRAB": "🦀",
            "LOBSTER": "🦞",
            "SHRIMP": "🦐",
            "SQUID": "🦑"
        },
        "BACK": {
            "COLD_FACE": "🥶",
            "CLOWN_FACE": "🤡",
            "LOVE_LETTER": "💌",
            "HEART_WITH_ARROW": "💘",
            "TWO_HEARTS": "💕",
            "BROKEN_HEART": "💔",
            "HEART_ON_FIRE": "❤️‍🔥",
            "MENDING_HEART": "❤️‍🩹",
            "SANTA_CLAUS": "🎅",
            "SUPERHERO": "🦸",
            "SUPERVILLAIN": "🦹",
            "MAN_MAGE": "🧙‍♂️",
            "MAN_VAMPIRE": "🧛‍♂️",
            "WOMAN_VAMPIRE": "🧛‍♀️",
            "MERMAN": "🧜‍♂️",
            "MERMAID": "🧜‍♀️",
            "ELF": "🧝",
            "MAN_ELF": "🧝‍♂️",
            "WOMAN_ELF": "🧝‍♀️",
            "ZOMBIE": "🧟",
            "MAN_ZOMBIE": "🧟‍♂️",
            "WOMAN_ZOMBIE": "🧟‍♀️",
            "PAW_PRINTS": "🐾",
            "SPIRAL_SHELL": "🐚",
            "CORAL": "🪸",
            "SPIDER_WEB": "🕸",
            "SUNFLOWER": "🌻",
            "POTTED_PLANT": "🪴",
            "EVERGREEN_TREE": "🌲",
            "DECIDUOUS_TREE": "🌳",
            "PALM_TREE": "🌴",
            "CACTUS": "🌵",
            "ICE": "🧊",
            "GLOBE_SHOWING_EUROPE-AFRICA": "🌍",
            "GLOBE_SHOWING_AMERICAS": "🌎",
            "GLOBE_SHOWING_ASIA-AUSTRALIA": "🌏",
            "WORLD_MAP": "🗺",
            "STADIUM": "🏟",
            "CLASSICAL_BUILDING": "🏛",
            "BRICK": "🧱",
            "HUT": "🛖",
            "HOUSE": "🏠",
            "HOUSE_WITH_GARDEN": "🏡",
            "OFFICE_BUILDING": "🏢",
            "JAPANESE_POST_OFFICE": "🏣",
            "POST_OFFICE": "🏤",
            "HOSPITAL": "🏥",
            "BANK": "🏦",
            "HOTEL": "🏨",
            "LOVE_HOTEL": "🏩",
            "CONVENIENCE_STORE": "🏪",
            "SCHOOL": "🏫",
            "DEPARTMENT_STORE": "🏬",
            "FACTORY": "🏭",
            "JAPANESE_CASTLE": "🏯",
            "CASTLE": "🏰",
            "WEDDING": "💒",
            "TOKYO_TOWER": "🗼",
            "STATUE_OF_LIBERTY": "🗽",
            "CHURCH": "⛪",
            "MOSQUE": "🕌",
            "HINDU_TEMPLE": "🛕",
            "SYNAGOGUE": "🕍",
            "SHINTO_SHRINE": "⛩",
            "KAABA": "🕋",
            "FOUNTAIN": "⛲",
            "TENT": "⛺",
            "BRIDGE_AT_NIGHT": "🌉",
            "FERRIS_WHEEL": "🎡",
            "ROLLER_COASTER": "🎢",
            "BARBER_POLE": "💈",
            "CIRCUS_TENT": "🎪",
            "LOCOMOTIVE": "🚂",
            "MOTOR_SCOOTER": "🛵",
            "BICYCLE": "🚲",
            "KICK_SCOOTER": "🛴",
            "SKATEBOARD": "🛹",
            "OIL_DRUM": "🛢",
            "FUEL_PUMP": "⛽",
            "WHEEL": "🛞",
            "POLICE_CAR_LIGHT": "🚨",
            "VERTICAL_TRAFFIC_LIGHT": "🚦",
            "STOP_SIGN": "🛑",
            "CONSTRUCTION": "🚧",
            "ANCHOR": "⚓",
            "RING_BUOY": "🛟",
            "HELICOPTER": "🚁",
            "HOURGLASS_DONE": "⌛",
            "HOURGLASS_NOT_DONE": "⏳",
            "ALARM_CLOCK": "⏰",
            "SNOWMAN": "☃",
            "SNOWMAN_WITHOUT_SNOW": "⛄",
            "FIRE": "🔥",
            "JACK-O-LANTERN": "🎃",
            "CHRISTMAS_TREE": "🎄",
            "SPORTS_MEDAL": "🏅",
            "1ST_PLACE_MEDAL": "🥇",
            "2ND_PLACE_MEDAL": "🥈",
            "3RD_PLACE_MEDAL": "🥉",
            "GOAL_NET": "🥅",
            "FLAG_IN_HOLE": "⛳",
            "BULLSEYE": "🎯",
            "CRYSTAL_BALL": "🔮",
            "SLOT_MACHINE": "🎰",
            "MIRROR_BALL": "🪩",
            "NESTING_DOLLS": "🪆",
            "SPADE_SUIT": "♠",
            "HEART_SUIT": "♥",
            "DIAMOND_SUIT": "♦",
            "CLUB_SUIT": "♣",
            "CHESS_PAWN": "♟",
            "JOKER": "🃏",
            "PERFORMING_ARTS": "🎭",
            "MUTED_SPEAKER": "🔇",
            "SPEAKER_HIGH_VOLUME": "🔊",
            "BELL_WITH_SLASH": "🔕",
            "MUSICAL_SCORE": "🎼",
            "MUSICAL_NOTE": "🎵",
            "MUSICAL_NOTES": "🎶",
            "STUDIO_MICROPHONE": "🎙",
            "RADIO": "📻",
            "TELEPHONE": "☎",
            "FAX_MACHINE": "📠",
            "BATTERY": "🔋",
            "LOW_BATTERY": "🪫",
            "LAPTOP": "💻",
            "PRINTER": "🖨",
            "TELEVISION": "📺",
            "RED_PAPER_LANTERN": "🏮",
            "DIYA_LAMP": "🪔",
            "PACKAGE": "📦",
            "TEAR-OFF_CALENDAR": "📆",
            "CHART_INCREASING": "📈",
            "CHART_DECREASING": "📉",
            "FILE_CABINET": "🗄",
            "WASTEBASKET": "🗑",
            "LOCKED": "🔒",
            "CROSSED_SWORDS": "⚔",
            "BALANCE_SCALE": "⚖",
            "LADDER": "🪜",
            "ALEMBIC": "⚗",
            "MICROSCOPE": "🔬",
            "TELESCOPE": "🔭",
            "DOOR": "🚪",
            "MIRROR": "🪞",
            "WINDOW": "🪟",
            "CHAIR": "🪑",
            "TOILET": "🚽",
            "SHOWER": "🚿",
            "MOUSE_TRAP": "🪤",
            "BASKET": "🧺",
            "BUCKET": "🪣",
            "COFFIN": "⚰",
            "HEADSTONE": "🪦",
            "FUNERAL_URN": "⚱",
            "NAZAR_AMULET": "🧿",
            "HAMSA": "🪬",
            "MOAI": "🗿",
            "MEN’S_ROOM": "🚹",
            "WOMEN’S_ROOM": "🚺",
            "RESTROOM": "🚻",
            "NO_ENTRY": "⛔",
            "PROHIBITED": "🚫",
            "NO_SMOKING": "🚭",
            "RADIOACTIVE": "☢",
            "BIOHAZARD": "☣",
            "ATOM_SYMBOL": "⚛",
            "MEDICAL_SYMBOL": "⚕",
            "RECYCLING_SYMBOL": "♻",
            "FLEUR-DE-LIS": "⚜",
            "RAINBOW_FLAG": "🏳️‍🌈",
            "TRANSGENDER_FLAG": "🏳️‍⚧️",
            "PIRATE_FLAG": "🏴‍☠️"
        }
    },


})

export default ENUMS